NtechApp.FormSaverManager = function(cb) {
    var me = this;

    me._forms = [];

    me._bindFormSavers();

    return this;
};

NtechApp.proto(NtechApp.FormSaverManager, {
    _bindFormSavers: function() {
        var me = this;
        $.each($("body").find("[data-saveManagerForm]"), function() {
            if(!NtechApp.dom.hasAttribute($(this).get(0), "data-customFormSaveManager"))
                me._createFormSaver($(this));
        });
    },

    _createFormSaver: function($formView) {
        var me = this;
        me._forms.push(new NtechApp.FormSaver(
            $formView,
            $formView.attr("data-saveManagerForm"),
            $formView.attr("data-saveManagerFormRedirect")
        ));
    },

    showCollectionErrors: function(formSaver, errorsData, rootFormName) {
        var allErrors = {};
        for(var formName in errorsData) {
            var errors = errorsData[formName];

            if(formName == rootFormName) {
                for(var i = 0; i < errors.length; i++) {
                    for(var errName in errors[i])
                        allErrors[errName] = errors[i][errName];
                }
            }
            else {
                for(var i = 0; i < errors.length; i++) {
                    for(var errName in errors[i]) {
                        var errTextPrefix = formName.substr(0, formName.length - 1);
                        var errTextPostfix = errTextPrefix.substr(1, errTextPrefix.length - 1);
                        var errText = errTextPrefix.charAt(0).toUpperCase() + errTextPostfix;

                        var text = errText + " form " + (i + 1) + ": " + errors[i][errName];
                        allErrors[formName + "_" + (i + 1) + "_" + errName] = text;
                    }
                }
            }
        }

        this._formSaver.showErrors(allErrors);
    }
});